import { useTheme } from '@mui/styles';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Popover,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { StaticDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { addNote, getNotes, postApiCall } from 'api/apiService';
import {
  BUYER_STORETASK,
  USER_STORETASK,
  USER_UPDATETASK,
} from 'constant/app.config';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import { TabPanel } from './OwnerCard';
import TemplateText from 'component/PropertyDetails/TemplateText';
import { title } from 'component/PropertyCreation/PropertyCreation.style';
import Swal from 'sweetalert2';
import Loading from 'assets/images/loading.png';
// import { TaskListCard } from "component/ExpandedBuyerCard/ExpendedCardDocumentation";
const ArrowDown = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.773438"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M13.1916 16.006C12.6967 16.5418 11.8501 16.5418 11.3552 16.006L7.28346 11.5982C6.54389 10.7976 7.11173 9.5 8.20165 9.5L16.3452 9.5C17.4351 9.5 18.003 10.7976 17.2634 11.5982L13.1916 16.006Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const Calendarimg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.43245C7 4.27684 7 4.19903 6.9491 4.15423C6.89819 4.10944 6.82244 4.11915 6.67094 4.13857C5.54965 4.28229 4.76806 4.57508 4.17157 5.17157C3 6.34315 3 8.22876 3 12C3 15.7712 3 17.6569 4.17157 18.8284C5.34315 20 7.22876 20 11 20H13C16.7712 20 18.6569 20 19.8284 18.8284C21 17.6569 21 15.7712 21 12C21 8.22876 21 6.34315 19.8284 5.17157C19.2319 4.57508 18.4504 4.28229 17.3291 4.13857C17.1776 4.11915 17.1018 4.10944 17.0509 4.15424C17 4.19903 17 4.27684 17 4.43245L17 6.5C17 7.32843 16.3284 8 15.5 8C14.6716 8 14 7.32843 14 6.5L14 4.30005C14 4.15898 14 4.08844 13.9561 4.04451C13.9123 4.00059 13.8418 4.0005 13.7009 4.00031C13.4748 4 13.2412 4 13 4H11C10.7588 4 10.5252 4 10.2991 4.00031C10.1582 4.0005 10.0877 4.00059 10.0439 4.04452C10 4.08844 10 4.15898 10 4.30005L10 6.5C10 7.32843 9.32843 8 8.50001 8C7.67158 8 7 7.32843 7 6.5L7 4.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M8.5 2.5L8.5 6.5" stroke="white" stroke-linecap="round" />
      <path d="M15.5 2.5L15.5 6.5" stroke="white" stroke-linecap="round" />
      <circle cx="7.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="16.5" r="0.5" fill="white" />
    </svg>
  );
};

const DownArrow = () => {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.369 10.3105C5.311 10.254 5.063 10.0406 4.859 9.84189C3.576 8.67677 1.476 5.63731 0.835 4.04647C0.732 3.80487 0.514 3.19406 0.5 2.86771C0.5 2.55499 0.572 2.25689 0.718 1.97243C0.922 1.61783 1.243 1.33337 1.622 1.1775C1.885 1.07715 2.672 0.921285 2.686 0.921285C3.547 0.765416 4.946 0.679688 6.492 0.679688C7.965 0.679688 9.307 0.765416 10.181 0.893034C10.195 0.907647 11.173 1.06352 11.508 1.234C12.12 1.54671 12.5 2.15752 12.5 2.8112V2.86771C12.485 3.29342 12.105 4.1887 12.091 4.1887C11.449 5.69381 9.452 8.66313 8.125 9.8565C8.125 9.8565 7.784 10.1926 7.571 10.3387C7.265 10.5667 6.886 10.6797 6.507 10.6797C6.084 10.6797 5.69 10.5521 5.369 10.3105Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
    </svg>
  );
};
const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};
const TaskDeleteIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.38152 12.0002H2.05334C1.64274 12.0002 1.29974 11.6793 1.27246 11.2696L0.764648 3.65234H9.67016L9.16235 11.2696C9.13512 11.6793 8.79213 12.0002 8.38152 12.0002ZM1.32239 4.17408L1.7931 11.2349C1.80218 11.3715 1.91649 11.4784 2.05334 11.4784H8.38147C8.51832 11.4784 8.63263 11.3715 8.64171 11.2349L9.11242 4.17408H1.32239Z"
        fill="#A58BC9"
      />
      <path
        d="M9.65179 3.1309H0.782227V1.82655C0.782227 1.39502 1.1333 1.04395 1.56484 1.04395H8.86918C9.30071 1.04395 9.65179 1.39502 9.65179 1.82655V3.1309ZM1.30397 2.60916H9.13005V1.82655C9.13005 1.68271 9.01303 1.56568 8.86918 1.56568H1.56484C1.42099 1.56568 1.30397 1.68271 1.30397 1.82655V2.60916Z"
        fill="#A58BC9"
      />
      <path d="M10.4348 2.6084H0V3.13014H10.4348V2.6084Z" fill="#A58BC9" />
      <path
        d="M3.91262 10.4342H3.39088C3.10272 10.4342 2.86914 10.2006 2.86914 9.91245V5.73854C2.86914 5.45038 3.10272 5.2168 3.39088 5.2168H3.91262C4.20078 5.2168 4.43436 5.45038 4.43436 5.73854V9.91245C4.43436 10.2006 4.20078 10.4342 3.91262 10.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M3.91275 10.6952H3.39101C2.95948 10.6952 2.6084 10.3441 2.6084 9.91258V5.73866C2.6084 5.30713 2.95948 4.95605 3.39101 4.95605H3.91275C4.34428 4.95605 4.69535 5.30713 4.69535 5.73866V9.91258C4.69535 10.3442 4.34428 10.6952 3.91275 10.6952ZM3.39101 5.47779C3.24716 5.47779 3.13014 5.59482 3.13014 5.73866V9.91258C3.13014 10.0564 3.24716 10.1734 3.39101 10.1734H3.91275C4.05659 10.1734 4.17362 10.0564 4.17362 9.91258V5.73866C4.17362 5.59482 4.05659 5.47779 3.91275 5.47779H3.39101Z"
        fill="#A58BC9"
      />
      <path
        d="M7.04348 10.4342H6.52174C6.23358 10.4342 6 10.2006 6 9.91245V5.73854C6 5.45038 6.23358 5.2168 6.52174 5.2168H7.04348C7.33163 5.2168 7.56522 5.45038 7.56522 5.73854V9.91245C7.56522 10.2006 7.33163 10.4342 7.04348 10.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M7.04361 10.6952H6.52187C6.09034 10.6952 5.73926 10.3441 5.73926 9.91258V5.73866C5.73926 5.30713 6.09034 4.95605 6.52187 4.95605H7.04361C7.47514 4.95605 7.82621 5.30713 7.82621 5.73866V9.91258C7.82621 10.3442 7.47514 10.6952 7.04361 10.6952ZM6.52187 5.47779C6.37802 5.47779 6.261 5.59482 6.261 5.73866V9.91258C6.261 10.0564 6.37802 10.1734 6.52187 10.1734H7.04361C7.18745 10.1734 7.30448 10.0564 7.30448 9.91258V5.73866C7.30448 5.59482 7.18745 5.47779 7.04361 5.47779H6.52187Z"
        fill="#A58BC9"
      />
      <path
        d="M6.52178 1.56522H3.91309V0.782609C3.91309 0.351078 4.26416 0 4.69569 0H5.73917C6.1707 0 6.52178 0.351078 6.52178 0.782609V1.56522ZM4.43483 1.04348H6.00004V0.782609C6.00004 0.638765 5.88302 0.521739 5.73917 0.521739H4.69569C4.55185 0.521739 4.43483 0.638765 4.43483 0.782609V1.04348Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const TaskEditIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25369 10.378L2.77907 10.5253C2.16461 10.7159 1.50993 11.0481 0.885968 11.4858L0.875874 11.4929L0.426999 11.0441L0.434199 11.034C0.871792 10.41 1.204 9.75531 1.39466 9.14093L1.54191 8.66637C1.57227 8.56848 1.51757 8.4645 1.41975 8.43414C1.32208 8.40386 1.21795 8.45841 1.18752 8.5563L1.04027 9.03086C0.860882 9.60902 0.546269 10.228 0.130421 10.8208L0.033714 10.9585C-0.0180907 11.0322 -0.00940716 11.1326 0.0543468 11.1963L0.723651 11.8655C0.759499 11.9014 0.807074 11.9198 0.854945 11.9198C0.89198 11.9198 0.929237 11.9088 0.961523 11.8861L1.09912 11.7895C1.69191 11.3736 2.31082 11.059 2.88906 10.8796L3.36369 10.7323C3.46151 10.702 3.51628 10.598 3.48585 10.5002C3.4555 10.4023 3.35159 10.3476 3.25369 10.378Z"
        fill="#A58BC9"
      />
      <path
        d="M9.05121 0.925478C8.9787 0.852966 8.86129 0.852966 8.78885 0.925478L2.43105 7.28328L1.71454 7.99986C1.64203 8.0723 1.64203 8.18979 1.71454 8.26222L3.6584 10.2061C3.69462 10.2423 3.74212 10.2604 3.78962 10.2604C3.83712 10.2604 3.88455 10.2423 3.92084 10.2061L4.63742 9.4895L10.9951 3.1317C11.0677 3.05927 11.0677 2.94178 10.9951 2.86934L9.05121 0.925478ZM3.78955 9.8125L2.10805 8.131L2.56219 7.67686L4.06505 9.17964L4.24377 9.35836L3.78955 9.8125ZM4.50613 9.09592L3.00327 7.59314L2.82456 7.41442L8.91999 1.31906L10.6015 3.00056L4.50613 9.09592Z"
        fill="#A58BC9"
      />
      <path
        d="M11.2794 1.50901L10.4114 0.641025C10.2232 0.452955 9.91729 0.453029 9.72922 0.641025L9.52802 0.842158C9.4555 0.914669 9.4555 1.03208 9.52802 1.1046C9.60053 1.17711 9.71794 1.17703 9.79038 1.1046L9.99159 0.903462C10.035 0.860119 10.1055 0.860044 10.1491 0.903462L11.017 1.77145C11.038 1.79253 11.0496 1.82051 11.0496 1.8502C11.0496 1.87996 11.038 1.90786 11.017 1.92894L10.8159 2.13008C10.7433 2.20259 10.7433 2.32 10.8159 2.39251C10.8521 2.42873 10.8996 2.44684 10.9471 2.44684C10.9946 2.44684 11.0421 2.42873 11.0783 2.39251L11.2794 2.19138C11.3706 2.10024 11.4207 1.97911 11.4207 1.8502C11.4207 1.72128 11.3706 1.60008 11.2794 1.50901Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const CheckRoundIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.273438"
        width="16.205"
        height="16.205"
        rx="8.1025"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
    </svg>
  );
};
const CheckedRoundIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.273438"
        width="16.205"
        height="16.205"
        rx="8.1025"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
      <path
        d="M4 9.5L7.33333 13L14 6"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

var styles = {
  ClickBanner: {
    height: '70px',
    backgroundColor: '#F8F8F8',
    marginTop: '-20px',
  },
  ClickText: {
    fontFamily: 'poppins',
    fontSize: '12px',
    fontWeight: 300,
    padding: '20px 0 0 10px',
    display: 'block',
    cursor: 'pointer',
  },
};

export const NotesTasks = ({
  data,
  buyerId,
  ownercardprop,
  rowData,
  setData,
  getNoteListApi,
  proid,
  selectedProperty,
  isEdit,
  setIsEdit,
  taskToEdit,
  setTaskToEdit,
  updateTaskScrollRef,
  updateNoteScrollRef,
  getTask,
  setTabValue,
  tabValue,
  setNoteToEdit,
  noteToEdit,
  isNoteEdit,
  setIsNoteEdit,
}) => {
  const handleTabValueChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const useStyles = makeStyles({
    tab: {
      minHeight: '36.68px',
    },
  });
  const classes = useStyles();
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const Notetask = ({ color = '#666666' }) => {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.23333 6.76667C4.23333 6.56667 4.36667 6.43333 4.56667 6.43333H8.83333C9.03333 6.43333 9.16667 6.56667 9.16667 6.76667C9.16667 6.96667 9.03333 7.1 8.83333 7.1H4.56667C4.4 7.1 4.23333 6.96667 4.23333 6.76667ZM4.56667 9.1H8.83333C9.03333 9.1 9.16667 8.96667 9.16667 8.76667C9.16667 8.56667 9.03333 8.43333 8.83333 8.43333H4.56667C4.36667 8.43333 4.23333 8.56667 4.23333 8.76667C4.23333 8.96667 4.4 9.1 4.56667 9.1ZM4.56667 11.0667H7.1C7.3 11.0667 7.43333 10.9333 7.43333 10.7333C7.43333 10.5333 7.3 10.4 7.1 10.4H4.56667C4.36667 10.4 4.23333 10.5333 4.23333 10.7333C4.23333 10.9 4.4 11.0667 4.56667 11.0667ZM14.1333 8.9C14.1333 9.06667 14.0667 9.23333 13.9333 9.36667L9.46667 13.7667C9.4 13.8333 9.33333 13.8667 9.26667 13.9L7.46667 14.6333C7.4 14.6667 7.1 14.7667 6.83333 14.5C6.66667 14.3333 6.6 14.1 6.7 13.8667L7.4 12.0667C7.43333 12 7.46667 11.9333 7.53333 11.8667L10.7333 8.7V4.66667H8.96667C8.76667 4.66667 8.63333 4.53333 8.63333 4.33333V2.66667H3.1C2.86667 2.66667 2.66667 2.86667 2.66667 3.1V12.5667C2.66667 12.8 2.86667 13 3.1 13H5.56667C5.76667 13 5.9 13.1333 5.9 13.3333C5.9 13.5333 5.76667 13.6667 5.56667 13.6667H3.1C2.5 13.6667 2 13.1667 2 12.5667V3.1C2 2.5 2.5 2 3.1 2H8.96667C9.1 2 9.16667 2.06667 9.2 2.1L11.3 4.1C11.4 4.2 11.4 4.33333 11.4 4.33333V8.03333L12 7.43333C12.2667 7.16667 12.6667 7.16667 12.9333 7.43333L13.9333 8.43333C14.0667 8.56667 14.1333 8.7 14.1333 8.9ZM9.3 4H10.2333L10.0667 3.83333L9.3 3.1V4ZM8.63333 13.4333L7.9 12.6667L7.4 13.9333L8.63333 13.4333ZM13.4667 8.86667L12.4667 7.9L8.26667 12.1L9.23333 13.1L13.4667 8.86667Z"
          fill={color}
        />
      </svg>
    );
  };
  const LocationIcon = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
          fill="#112347"
        />
      </svg>
    );
  };
  const ArrowDown = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.03091 12.2803C7.98982 12.2403 7.81416 12.0892 7.66966 11.9484C6.76086 11.1231 5.27336 8.97015 4.81932 7.8433C4.74636 7.67217 4.59195 7.23951 4.58203 7.00834C4.58203 6.78684 4.63303 6.57568 4.73645 6.37419C4.88095 6.12301 5.10832 5.92152 5.37678 5.81111C5.56307 5.74004 6.12053 5.62963 6.13045 5.62963C6.74032 5.51922 7.73128 5.4585 8.82636 5.4585C9.86974 5.4585 10.8203 5.51922 11.4394 5.60962C11.4493 5.61997 12.1421 5.73037 12.3794 5.85113C12.8129 6.07264 13.082 6.5053 13.082 6.96832V7.00834C13.0714 7.30989 12.8022 7.94405 12.7923 7.94405C12.3376 9.01017 10.923 11.1134 9.98307 11.9587C9.98307 11.9587 9.74153 12.1968 9.59066 12.3003C9.37391 12.4618 9.10545 12.5418 8.83699 12.5418C8.53736 12.5418 8.25828 12.4514 8.03091 12.2803Z"
          fill="#112347"
        />
      </svg>
    );
  };

  const TaskList = ({ color = '#666666' }) => {
    return (
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2188 3.40625H9.10359C8.95847 2.99705 8.5677 2.70312 8.10938 2.70312H7.69758C7.55248 2.29388 7.16149 2 6.70312 2C6.24476 2 5.85377 2.29388 5.70867 2.70312H5.29688C4.83855 2.70312 4.44778 2.99705 4.30266 3.40625H3.1875C2.60595 3.40625 2.13281 3.87938 2.13281 4.46094V12.9453C2.13281 13.5269 2.60595 14 3.1875 14H10.2188C10.8003 14 11.2734 13.5269 11.2734 12.9453V4.46094C11.2734 3.87938 10.8003 3.40625 10.2188 3.40625ZM4.94531 3.75781C4.94531 3.56396 5.10302 3.40625 5.29688 3.40625H6C6.19416 3.40625 6.35156 3.24884 6.35156 3.05469C6.35156 2.86084 6.50927 2.70312 6.70312 2.70312C6.89698 2.70312 7.05469 2.86084 7.05469 3.05469C7.05469 3.24884 7.21209 3.40625 7.40625 3.40625H8.10938C8.30323 3.40625 8.46094 3.56396 8.46094 3.75781V4.10938H4.94531V3.75781ZM10.5703 12.9453C10.5703 13.1392 10.4126 13.2969 10.2188 13.2969H3.1875C2.99365 13.2969 2.83594 13.1392 2.83594 12.9453V4.46094C2.83594 4.26709 2.99365 4.10938 3.1875 4.10938H4.24219V4.46094C4.24219 4.65509 4.39959 4.8125 4.59375 4.8125H8.8125C9.00666 4.8125 9.16406 4.65509 9.16406 4.46094V4.10938H10.2188C10.4126 4.10938 10.5703 4.26709 10.5703 4.46094V12.9453Z"
          fill={color}
        />
        <path
          d="M6.24859 8.12641C6.11132 7.98911 5.88871 7.98911 5.75141 8.12641L4.59376 9.28406L4.13921 8.82951C4.00194 8.69221 3.77933 8.69221 3.64204 8.82951C3.50474 8.96681 3.50474 9.18939 3.64204 9.32669L4.34518 10.0298C4.41381 10.0985 4.50379 10.1328 4.59376 10.1328C4.68374 10.1328 4.77372 10.0985 4.84234 10.0298L6.24859 8.62359C6.38589 8.48629 6.38589 8.26371 6.24859 8.12641Z"
          fill={color}
        />
        <path
          d="M6.24859 5.66547C6.11132 5.52818 5.88871 5.52818 5.75141 5.66547L4.59376 6.82312L4.13921 6.36857C4.00194 6.23128 3.77933 6.23128 3.64204 6.36857C3.50474 6.50587 3.50474 6.72846 3.64204 6.86575L4.34518 7.5689C4.41381 7.63755 4.50379 7.67186 4.59376 7.67186C4.68374 7.67186 4.77372 7.63755 4.84234 7.5689L6.24859 6.16265C6.38589 6.02536 6.38589 5.80277 6.24859 5.66547Z"
          fill={color}
        />
        <path
          d="M6.24859 10.5873C6.11132 10.4501 5.88871 10.4501 5.75141 10.5873L4.59376 11.745L4.13921 11.2905C4.00194 11.1532 3.77933 11.1532 3.64204 11.2905C3.50474 11.4278 3.50474 11.6504 3.64204 11.7877L4.34518 12.4908C4.41381 12.5594 4.50379 12.5938 4.59376 12.5938C4.68374 12.5938 4.77372 12.5594 4.84234 12.4908L6.24859 11.0845C6.38589 10.9472 6.38589 10.7246 6.24859 10.5873Z"
          fill={color}
        />
        <path
          d="M9.51562 6.26562H7.40625C7.21209 6.26562 7.05469 6.42303 7.05469 6.61719C7.05469 6.81134 7.21209 6.96875 7.40625 6.96875H9.51562C9.70978 6.96875 9.86719 6.81134 9.86719 6.61719C9.86719 6.42303 9.70978 6.26562 9.51562 6.26562Z"
          fill={color}
        />
        <path
          d="M9.51562 11.1875H7.40625C7.21209 11.1875 7.05469 11.3449 7.05469 11.5391C7.05469 11.7332 7.21209 11.8906 7.40625 11.8906H9.51562C9.70978 11.8906 9.86719 11.7332 9.86719 11.5391C9.86719 11.3449 9.70978 11.1875 9.51562 11.1875Z"
          fill={color}
        />
        <path
          d="M9.51562 8.72656H7.40625C7.21209 8.72656 7.05469 8.88397 7.05469 9.07812C7.05469 9.27228 7.21209 9.42969 7.40625 9.42969H9.51562C9.70978 9.42969 9.86719 9.27228 9.86719 9.07812C9.86719 8.88397 9.70978 8.72656 9.51562 8.72656Z"
          fill={color}
        />
      </svg>
    );
  };
  const theme = useTheme();
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const isLg = useMediaQuery((theme) => theme.breakpoints.only('lg'));
  const isXl = useMediaQuery((theme) => theme.breakpoints.only('xl'));
  return (
    <Grid
      container
      sx={{
        background: '#FFFFFF',
        // marginTop: "10px",
        display: 'flex',
        flexDirection: 'column',
        padding: '15px 15px 20px 15px',
        borderRadius: '5px',
      }}
    >
      <Grid
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: isMd || isSm || isXs ? 'column' : 'row',
          justifyContent: 'space-between',
          height: isMd || isSm || isXs ? 'auto' : '36px',
        }}
      >
        <Grid item>
          <Tabs
            style={{
              color: 'purpleHeart',
              borderBottom: 'purpleheart',
              display: 'false',
            }}
            value={tabValue}
            onChange={handleTabValueChange}
            aria-label=" tabs example"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#fffff',
                marginBottom: '5px',
              },
              '& .MuiTab-root.Mui-selected': {
                color: '#2F74EE',
                background: 'rgba(0, 101, 252, 0.1)',
                // width: "67.13px",
                height: '36.68px',
                p: '0px',
              },
            }}
          >
            <Tab
              style={{ minHeight: '39.68px', padding: '0px' }}
              className={classes.tab}
              label="Notes"
              icon={<Notetask color={tabValue == 0 ? '#0065FC' : '#666666'} />}
              iconPosition="start"
              {...a11yProps(0)}
              sx={{
                fontFamily: 'Poppins !important',
                fontStyle: 'normal !important',
                fontWeight: '400 !important',
                fontSize: '12px',
                textTransform: 'capitalize',
              }}
            />

            <Tab
              style={{ minHeight: '39.68px', padding: '0px' }}
              className={classes.tab}
              label="Task"
              icon={<TaskList color={tabValue == 1 ? '#0065FC' : '#666666'} />}
              iconPosition="start"
              {...a11yProps(1)}
              sx={{
                fontFamily: 'Poppins !important',
                fontStyle: 'normal !important',
                fontWeight: '400 !important',
                fontSize: '12px',
                // color: "#9A9A9F",
                textTransform: 'none',
              }}
            />
          </Tabs>
        </Grid>
        <Grid
          item
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '5px',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '5px',
              alignItems: 'flex-start',
            }}
          >
            <LocationIcon />
            <Typography
              sx={{
                ...poppins300,
                fontSize: '12px',
              }}
            >
              {selectedProperty}
            </Typography>
            {/* <ArrowDown /> */}
          </Box>
          <Box>
            <CancelOutlinedIcon />
          </Box>
        </Grid>
      </Grid>
      <Grid
        xs={12}
        item
        sx={{
          display: 'flex',
          // background: "#F8F8F8",
          borderRadius: '5px',
          // height: "69px",
          width: '100%',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <TabPanel value={tabValue} index={0} sx={{ width: '100%' }}>
          <NotesTake
            getNoteListApi={getNoteListApi}
            data={data}
            setNoteToEdit={setNoteToEdit}
            noteToEdit={noteToEdit}
            isNoteEdit={isNoteEdit}
            setIsNoteEdit={setIsNoteEdit}
            setData={setData}
            rowData={rowData}
            buyerId={buyerId}
            updateNoteScrollRef={updateNoteScrollRef}
            ownercardprop={ownercardprop}
            proid={proid}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1} sx={{ width: '100%' }}>
          <TaskTake
            proid={proid}
            buyerId={buyerId}
            selectedProperty={selectedProperty}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            taskToEdit={taskToEdit}
            setTaskToEdit={setTaskToEdit}
            updateTaskScrollRef={updateTaskScrollRef}
            updateNoteScrollRef={updateNoteScrollRef}
            getTask={getTask}
            tabValue={tabValue}
          />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

function NotesTake({
  buyerId,
  ownercardprop,
  rowData,
  setData,
  setNoteToEdit,
  noteToEdit,
  isNoteEdit,
  setIsNoteEdit,
  data,
  getNoteListApi,
  proid,
  updateNoteScrollRef,
}) {
  const [age, setAge] = React.useState('');
  const { dashboardId } = useParams();
  const [anchorElMessage, setAnchorElMessage] = useState(false);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const style = {
    display: 'flex',
    flexDirection: 'column',
    // gap: "20px",
    width: '100%',
    fontFamily: 'poppins',
  };

  const notesMidLine = {
    color: '#666',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  };
  const [subject, setSubject] = useState('');
  const [details, setDetails] = useState('');
  const [butValue, setButValue] = useState(true);
  const [errors, setErrors] = useState({ subject: '', details: '' });

  const validate = () => {
    let valid = true;
    let newErrors = { subject: '', details: '' };

    if (!subject.trim()) {
      newErrors.subject = 'Subject is required';
      valid = false;
    }

    if (!details.trim()) {
      newErrors.details = 'Details are required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  useEffect(() => {
    setButValue(subject && details ? false : true);
  }, [subject, details]);

  // const submitForm = () => {
  //   if (!validate()) return;
  //   if (subject != '' && details != '') {
  //     let input = {
  //       buyerId: buyerId,
  //       propertyId: proid,
  //       subject: subject,
  //       message: details,
  //     };
  //     if (ownercardprop) {
  //       addVendorNotes(input, rowData, proid).then((res) => {
  //         setSubject('');
  //         setDetails('');
  //         getVendorNotes(rowData.user.userId, proid).then((res) => {
  //           setData(res?.data);
  //         });
  //       });
  //     } else {
  //       addBuyerNotes(input, proid, rowData?.inspectionBuyerId).then((res) => {
  //         setSubject('');
  //         setDetails('');
  //         getBuyerNotes(buyerId, proid).then((res) => {
  //           setData(res?.data);
  //           Swal.fire({
  //             title: res?.heading,
  //             text: res?.message,
  //             showDenyButton: false,
  //             showCancelButton: false,
  //             icon: 'success',
  //             confirmButtonText: 'Close',
  //           });
  //         });
  //       });
  //     }
  //   }
  // };

  //   const submitForm = () => {
  //   if (!validate()) return;

  //   if (subject !== '' && details !== '') {
  //     setIsLoading(true); // 🔹 Start loader

  //     let input = {
  //       // buyerId: buyerId,
  //       // propertyId: proid,
  //       // subject: subject,
  //       // message: details,
  //     };

  //     if (ownercardprop) {
  //       addVendorNotes(input, rowData, proid)
  //         .then((res) => {
  //           setSubject('');
  //           setDetails('');
  //           getVendorNotes(rowData.user.userId, proid).then((res) => {
  //             setData(res?.data);
  //           });
  //         })
  //         .finally(() => {
  //           setIsLoading(false); // 🔹 Stop loader
  //         });
  //     } else {
  //       addBuyerNotes(input, proid, rowData?.inspectionBuyerId)
  //         .then((res) => {
  //           setSubject('');
  //           setDetails('');
  //           getBuyerNotes(buyerId, proid).then((res) => {
  //             setData(res?.data);
  //             Swal.fire({
  //               title: res?.heading,
  //               text: res?.message,
  //               showDenyButton: false,
  //               showCancelButton: false,
  //               icon: 'success',
  //               confirmButtonText: 'Close',
  //             });
  //           });
  //         })
  //         .finally(() => {
  //           setIsLoading(false); // 🔹 Stop loader
  //         });
  //     }
  //   }
  // };

  const submitForm = () => {
    if (!validate()) return;

    if (subject !== '' && details !== '') {
      setIsLoading(true); // 🔹 Start loader

      const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
      const targetUserId = ownercardprop ? rowData?.user?.userId : buyerId;

      let input = {
        receiverType: targetUserType,
        receiverId: targetUserId,
        propertyId: proid,
        subject: subject,
        message: details,
      };

      addNote(input)
        .then((res) => {
          if (res?.status == 1) {
            setSubject('');
            setDetails('');
            getNotes({
              receiverType: targetUserType,
              receiverId: targetUserId,
              filter: 'property',
              propertyId: proid,
            }).then((getRes) => {
              setData(getRes?.data);
              if (!ownercardprop) {
                Swal.fire({
                  title: res?.heading,
                  text: res?.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  icon: 'success',
                  confirmButtonText: 'Close',
                });
              }
            });
          } else {
            Swal.fire({
              title: 'Error',
              text: res?.message || 'Something went wrong',
              icon: 'error',
              confirmButtonText: 'Close',
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: 'Error',
            text: 'Something went wrong',
            icon: 'error',
            confirmButtonText: 'Close',
          });
        })
        .finally(() => {
          setIsLoading(false); // 🔹 Stop loader
        });
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  const [expandNote, setExpandNote] = useState(true);

  const clicktoExpand = () => {
    setExpandNote(false);
  };

  useEffect(() => {
    if (isNoteEdit) {
      setSubject(noteToEdit.subject);
      setDetails(noteToEdit.notesMessage);
    }
  }, [isNoteEdit, noteToEdit]);

  const handleUpdateNote = () => {
    if (!validate()) return;
    if (subject != '' && details != '') {
      const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
      const targetUserId = ownercardprop ? rowData?.user?.userId : buyerId;

      let input = {
        receiverType: targetUserType,
        receiverId: targetUserId,
        propertyId: proid,
        subject: subject,
        message: details,
        notesId: noteToEdit.noteId,
      };

      addNote(input).then((res) => {
        setSubject('');
        setDetails('');
        setNoteToEdit(null);
        setIsNoteEdit(null);
        getNotes({
          receiverType: targetUserType,
          receiverId: targetUserId,
          filter: 'property',
          propertyId: proid,
        }).then((getRes) => {
          setData(getRes?.data);
          if (!ownercardprop) {
            Swal.fire({
              title: 'Note Updated',
              text: 'Note Updated Successfuly',
              showDenyButton: false,
              showCancelButton: false,
              icon: 'success',
              confirmButtonText: 'Close',
            });
          }
        });
      });
    }
  };

  return (
    <Grid container sx={style} ref={updateNoteScrollRef}>
      {expandNote && !isNoteEdit ? (
        <Grid sx={styles.ClickBanner}>
          <Typography onClick={clicktoExpand} sx={styles.ClickText}>
            Click here to add a note
          </Typography>
        </Grid>
      ) : (
        <Grid>
          <Grid xs={12}>
            <Grid
              xs={12}
              sm={12}
              container
              sx={{
                display: ' flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                // border : '1px solid'
              }}
            >
              <Grid xs={8} xl={8.8}>
                <TextField
                  sx={{
                    width: '100%',
                    borderRadius: '0px',
                    '&.MuiOutlinedInput-input': {
                      textTransform: 'capitalize',
                    },
                    '& .MuiOutlinedInput-root': {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                    '& .MuiInputLabel-root': {
                      fontFamily: 'poppins',
                      // border:"1px solid green",
                      marginRight: '0px',
                    },
                    '.MuiFormHelperText-contained': {
                      margin: '0',
                      fontFamily: 'poppins',
                    },
                  }}
                  disabled={isLoading}
                  variant="outlined"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputLabelProps={{
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                  error={!!errors.subject}
                  helperText={errors.subject}
                  // inputProps={{ style: { fontFamily: "poppins" } }}
                />
              </Grid>
              <Grid
                xs={3}
                xl={3}
                sx={{
                  ...poppins400,
                  display: 'flex',
                  justifyContent: 'space-between',
                  border: '1px solid #D9D9D9',
                  padding: matchessm ? '5px' : '15px',
                  borderRadius: '4px',
                }}
              >
                <Typography
                  sx={{ ...poppins400, fontSize: matchessm ? '12px' : '18px' }}
                >
                  {ownercardprop ? 'Vendor Report' : 'Buyer Report'}
                </Typography>
                <IconButton>
                  <DownArrow />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ marginTop: '15px' }}>
            <TextField
              sx={{
                width: '100%',
                borderRadius: '0px',
                '& .MuiOutlinedInput-root': {
                  fontFamily: 'poppins',
                },
                '& .MuiInputLabel-root': {
                  fontFamily: 'poppins',
                },
                '.MuiFormHelperText-contained': {
                  margin: '0',
                  fontFamily: 'poppins',
                },
              }}
              disabled={isLoading}
              variant="outlined"
              placeholder="Details"
              multiline
              value={details}
              rows={6}
              error={!!errors.details}
              helperText={errors.details}
              onChange={(e) => {
                let value = e.target.value;
                value =
                  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                setDetails(value);
              }}
              inputProps={{ style: { fontFamily: 'poppins' } }}
            />
          </Grid>
          <Grid
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              alignItems: matchessm ? 'left' : 'center',
              gap: '10px',
              justifyContent: 'end',
              fontFamily: 'poppins',
              marginTop: matchessm ? '10px' : '20px',
            }}
          >
            <Typography sx={{ fontFamily: 'poppins', color: '#737497' }}>
              Tags -{' '}
              <Typography
                sx={{
                  padding: '5px 10px',
                  background: '#0BC4ED',
                  borderRadius: '5px',
                  color: 'white',
                  fontFamily: 'poppins',
                }}
              >
                #Public
              </Typography>{' '}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                padding: '10px',
                fontWeight: 500,
                fontSize: '12px',
                fontFamily: 'poppins',
                color: 'black',
                borderColor: '#D9D9D9',
                width: 'fit-content',
              }}
              onClick={(e) => {
                setAnchorElMessage(e.currentTarget);
              }}
            >
              + Insert Template Text
            </Button>
            <TemplateText
              anchorElMessage={anchorElMessage}
              setAnchorElMessage={setAnchorElMessage}
              setDetails={setDetails}
            />

            {isNoteEdit ? (
              <Button
                variant="outlined"
                sx={{
                  padding: '10px 15px',
                  borderRadius: '5px',
                  fontWeight: 400,
                  letterSpacing: '1px',
                  fontSize: '12px',
                  background: '#ECE5F6',
                  color: '#6C2AD2',
                  fontFamily: 'poppins',
                  textTransform: 'capitalize',
                  border: 'none',
                  '&:hover': {
                    border: 'none',
                    background: '#e5d0ff',
                  },
                }}
                onClick={() => {
                  handleUpdateNote();
                }}
              >
                Update
              </Button>
            ) : (
              <Button
                // disabled={butValue}
                variant="outlined"
                sx={{
                  width: '60px',
                  padding: '8px 15px',
                  fontWeight: 400,
                  borderRadius: '5px',
                  letterSpacing: '1px',
                  fontSize: '12px',
                  background: '#ECE5F6',
                  color: '#6C2AD2',
                  fontFamily: 'poppins',
                  border: 'none',
                  '&:hover': {
                    border: 'none',
                    background: '#e5d0ff',
                  },
                }}
                onClick={submitForm}
              >
                Save
              </Button>
            )}
            {isLoading && (
              <img
                alt="Loader"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }} // 🔹 smaller & aligned
              />
            )}

            {/* </Box> */}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

const DidnotConnectIcon = ({ color }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23057_78956)">
        <path
          d="M6 42L42 6"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.662 28.322C8.30892 23.5059 6.34969 17.858 6 12C6 10.9391 6.42143 9.92172 7.17157 9.17157C7.92172 8.42143 8.93913 8 10 8H18L22 18L17 21C17.216 21.44 17.446 21.87 17.69 22.29M21.192 26.844C22.878 28.524 24.836 29.932 27 31L30 26L40 30V38C40 39.0609 39.5786 40.0783 38.8284 40.8284C38.0783 41.5786 37.0609 42 36 42C28.1962 41.533 20.835 38.2189 15.312 32.686"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_23057_78956">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const VoicemailLeftIcon = ({ color }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0008 30C21.2562 28.3286 22 26.2512 22 24C22 18.4772 17.5228 14 12 14C6.47716 14 2 18.4772 2 24C2 29.5228 6.47716 34 12 34H36C41.5228 34 46 29.5228 46 24C46 18.4772 41.5228 14 36 14C30.4772 14 26 18.4772 26 24C26 26.2512 26.7438 28.3286 27.9992 30H20.0008ZM12 30C15.3137 30 18 27.3138 18 24C18 20.6862 15.3137 18 12 18C8.6863 18 6 20.6862 6 24C6 27.3138 8.6863 30 12 30ZM36 30C39.3138 30 42 27.3138 42 24C42 20.6862 39.3138 18 36 18C32.6862 18 30 20.6862 30 24C30 27.3138 32.6862 30 36 30Z"
        fill={color}
      />
    </svg>
  );
};
const NoVoicemailLeftIcon = ({ color }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0008 30C21.2562 28.3286 22 26.2512 22 24C22 18.4772 17.5228 14 12 14C6.47716 14 2 18.4772 2 24C2 29.5228 6.47716 34 12 34H36C41.5228 34 46 29.5228 46 24C46 18.4772 41.5228 14 36 14C30.4772 14 26 18.4772 26 24C26 26.2512 26.7438 28.3286 27.9992 30H20.0008ZM12 30C15.3137 30 18 27.3138 18 24C18 20.6862 15.3137 18 12 18C8.6863 18 6 20.6862 6 24C6 27.3138 8.6863 30 12 30ZM36 30C39.3138 30 42 27.3138 42 24C42 20.6862 39.3138 18 36 18C32.6862 18 30 20.6862 30 24C30 27.3138 32.6862 30 36 30Z"
        fill={color}
      />
      <line
        x1="39.4142"
        y1="11.4142"
        x2="8.41421"
        y2="42.4142"
        stroke="#FEFEFE"
        stroke-width="4"
      />
      <path
        d="M46 7L9 43"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
const CallConnectedIcon = ({ color }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23057_78963)">
        <path
          d="M10 8H18L22 18L17 21C19.1419 25.3431 22.6569 28.8581 27 31L30 26L40 30V38C40 39.0609 39.5786 40.0783 38.8284 40.8284C38.0783 41.5786 37.0609 42 36 42C28.1985 41.5259 20.8403 38.213 15.3137 32.6863C9.78701 27.1597 6.4741 19.8015 6 12C6 10.9391 6.42143 9.92172 7.17157 9.17157C7.92172 8.42143 8.93913 8 10 8Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30 12L34 16L42 8"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_23057_78963">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

function TaskTake({
  proid,
  buyerId,
  selectedProperty,
  isEdit,
  setIsEdit,
  taskToEdit,
  setTaskToEdit,
  updateTaskScrollRef,
  getTask,
  tabValue,
}) {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    fontFamily: 'poppins',
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [subject, setSubject] = useState('');
  const [details, setDetails] = useState('');
  const [subjectsch, setSubjectsch] = useState('');
  const [detailssch, setDetailssch] = useState('');
  const [calender, setCalender] = useState('');
  const [options, setOptions] = useState('To-do');
  const [optionsTask, setOptionsTask] = useState('To-do');
  //datetime picker anchor
  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorElMessage, setAnchorElMessage] = useState(false);

  const [errorMessages, setErrorMessage] = useState({
    subject: false,
    details: false,
    dueDate: false,
    dateRange: false,
  });

  const [errorMessagesSch, setErrorMessageSch] = useState({
    subjectSch: false,
    detailsSch: false,
    dateSch: false,
    dateRangeSch: false,
  });

  const [checkBox1, setcheckBox1] = useState(false);
  const [checkBox2, setcheckBox2] = useState(false);
  //formattedd date
  const [filterDate, setfilterDate] = useState(null);
  const [duedate, setDuedate] = useState(null);
  const [filterDateform, setfilterDateform] = useState(null);
  const [duedateform, setDuedateform] = useState(null);
  //selected date
  const [newDateValue, setnewDate] = useState(null);
  //Call Outcome dialog state
  const [taskSave, settaskSave] = useState(null);
  const [schedule, setSchedule] = useState(false);

  const [expandNote, setExpandNote] = useState(true);
  const [callcategory, setCallcategory] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  const handleUpdateTask = () => {
    const inputData = {
      binderId: taskToEdit?.binder_id,
      assigneeId: buyerId,
      transId: taskToEdit?.transobject?.id,
      title: subject,
      isDone: 0,
      isDelete: 0,
      comment: details,
      dueDateTime: duedateform,
      isSchedule: checkBox1 ? 1 : 0,
      scheduleTitle: subjectsch,
      scheduleComment: detailssch,
      scheduleDueDateTime: filterDateform,
      taskType: optionsTask,
      propertyId: proid,
    };
    setIsLoading(true);
    postApiCall(USER_UPDATETASK, inputData).then((res) => {
      setIsLoading(false);
      if (res?.data?.status == 1) {
        setSubject('');
        setDetails('');
        setDuedate(null);
        setSubjectsch('');
        setDetailssch('');
        setcheckBox1(false);
        setcheckBox2(false);
        setfilterDate(null);
        setfilterDateform(null);
        setDuedate(null);
        setDuedateform(null);
        setErrorMessage({
          subject: false,
          details: false,
          dueDate: false,
        });
        setTaskToEdit(null);
        setIsEdit(false);
        getTask();
        Swal.fire({
          title: 'Update',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const handleSaveTaskClicked = () => {
    if (subject == '') {
      setErrorMessage((prev) => ({
        ...prev,
        subject: true,
      }));
    } else if (details == '') {
      setErrorMessage((prev) => ({
        ...prev,
        details: true,
      }));
    } else if (duedate == null) {
      setErrorMessage((prev) => ({
        ...prev,
        dueDate: true,
      }));
    } else {
      if (isEdit) {
        handleUpdateTask();
      } else {
        handleSaveTask();
        setErrorMessage((prev) => ({
          ...prev,
          dateRange: false,
        }));
      }
    }
  };

  const handleSaveSchClicked = () => {
    if (subjectsch == '') {
      setErrorMessageSch((prev) => ({
        ...prev,
        subjectSch: true,
      }));
    } else if (detailssch == '') {
      setErrorMessageSch((prev) => ({
        ...prev,
        detailsSch: true,
      }));
    } else if (filterDateform == null) {
      setErrorMessageSch((prev) => ({
        ...prev,
        dateSch: true,
      }));
    } else {
      setSchedule(false);
      setErrorMessageSch((prev) => ({
        ...prev,
        dateRangeSch: false,
      }));
    }
  };

  // const handleSaveTask = () => {
  //   const taskData = {
  //     // propertyId: proid,
  //     // assigneeId: buyerId,
  //     // title: subject,
  //     // comment: details,
  //     // dueDateTime: duedateform,
  //     // isSchedule: checkBox1 ? 1 : 0,
  //     // scheduleTitle: subjectsch,
  //     // scheduleComment: detailssch,
  //     // scheduleDueDateTime: filterDateform,
  //     // taskType: optionsTask,
  //     isDone: checkBox2 ? 1 : 0,
  //   };

  //   setIsLoading(true);
  //   postApiCall(USER_STORETASK, taskData).then((res) => {
  //     setIsLoading(false);
  //     if (res?.data?.status == 1) {
  //       settaskSave(true);
  //       setSubject('');
  //       setDetails('');
  //       setDuedate(null);
  //       setSubjectsch('');
  //       setDetailssch('');
  //       setcheckBox1(false);
  //       setcheckBox2(false);
  //       setfilterDate(null);
  //       setfilterDateform(null);
  //       setDuedate(null);
  //       setDuedateform(null);
  //       setErrorMessage({
  //         subject: false,
  //         details: false,
  //         dueDate: false,
  //       });
  //       getTask();
  //       Swal.fire({
  //         title: 'Task Created',
  //         text: res?.data?.message,
  //         showDenyButton: false,
  //         showCancelButton: false,
  //         icon: 'success',
  //         confirmButtonText: 'Close',
  //       });
  //     }
  //   });
  // };

  const handleSaveTask = () => {
    const taskData = {
      propertyId: proid,
      assigneeId: buyerId,
      title: subject,
      comment: details,
      dueDateTime: duedateform,
      isSchedule: checkBox1 ? 1 : 0,
      scheduleTitle: subjectsch,
      scheduleComment: detailssch,
      scheduleDueDateTime: filterDateform,
      taskType: optionsTask,
      isDone: checkBox2 ? 1 : 0,
    };

    setIsLoading(true);
    postApiCall(USER_STORETASK, taskData)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status == 1) {
          // settaskSave(true);
          setSubject('');
          setDetails('');
          setDuedate(null);
          setSubjectsch('');
          setDetailssch('');
          setcheckBox1(false);
          setcheckBox2(false);
          setfilterDate(null);
          setfilterDateform(null);
          setDuedate(null);
          setDuedateform(null);
          setErrorMessage({
            subject: false,
            details: false,
            dueDate: false,
          });
          getTask();
          Swal.fire({
            title: 'Task Created',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
        } else {
          // 🔴 Added Error Swal
          Swal.fire({
            title: 'Error',
            text: res?.data?.message || 'Something went wrong',
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        // 🔴 Network/Unexpected error
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'Close',
        });
        console.error('Error creating task:', error);
      });
  };

  const clicktoExpand = () => {
    setExpandNote(false);
  };

  const submitForm = () => {
    const params = {
      propertyId: Number(proid),
      assigneeId: buyerId,
      title: subject,
      comment: details,
      dueDateTime: duedateform,
      isSchedule: checkBox1 ? 1 : 0,
      scheduleTitle: subjectsch,
      scheduleComment: detailssch,
      scheduleDueDateTime: filterDateform,
      taskType: optionsTask,
    };
    postApiCall(USER_STORETASK, params).then((res) => {
      if (res?.data?.status == 1) {
        setSubject('');
        setDetails('');
        setDuedate(null);
        setSubjectsch('');
        setDetailssch('');
        setcheckBox1(false);
        setcheckBox2(false);
        setfilterDate(null);
        setfilterDateform(null);
        setDuedate(null);
        setDuedateform(null);
      }
    });
  };

  // datetime picker close function
  const handleClose = () => {
    setAnchorEl(null);
  };

  const nowSydneyDueDate = dayjs().tz('Australia/Sydney');
  const oneHourLaterDueDate = nowSydneyDueDate.add(1, 'hour');
  const twoHourLaterDueDate = nowSydneyDueDate.add(2, 'hour');
  const [scheduledate, setScheduleDate] = useState(null);
  //datetime picker values filter
  const getDateValue = (newdate) => {
    if (newdate !== null) {
      const formattedDate = dayjs(newdate)
        .locale('en') // Set locale for month name
        .format('DD MMMM YYYY [at] hh:mma');

      const formatted = dayjs(newdate)
        .locale('en')
        .format('YYYY-MM-DD HH:mm:ss');

      if (calender === 'Due') {
        setDuedateform(formatted);
        setDuedate(formattedDate);

        const nowSydney = dayjs().tz('Australia/Sydney'); // Current Sydney time
        const oneHourFiveMinutesLater = nowSydney
          .add(1, 'hour')
          .add(1, 'minutes'); // 1 hour & 5 minutes ahead
        const selectedDate = dayjs(newdate).tz('Australia/Sydney'); // Ensure new date is in Sydney timezone

        const isFuture = selectedDate.isAfter(oneHourFiveMinutesLater); // Check if it's at least 1hr 5mins later
        setScheduleDate(isFuture); // Set true only if condition is met
      } else {
        setfilterDateform(formatted);
        setfilterDate(formattedDate);
      }
    }
  };

  useEffect(() => {
    if (isEdit) {
      setSubject(taskToEdit?.transobject?.title);
      setDetails(taskToEdit?.transobject?.sub_title);
      const duedate = dayjs(taskToEdit?.transobject?.expiration_date)
        .locale('en')
        .format('DD MMMM YYYY [at] hh:mma');
      const formatteddate = dayjs(taskToEdit?.transobject?.expiration_date)
        .locale('en')
        .format('YYYY-MM-DD HH:mm:ss');
      setDuedate(duedate);
      setDuedateform(formatteddate);
      const taskcode = taskToEdit?.transobject?.type;
      if (taskcode == 'TRANSACTION_TYPE_TODO') {
        setOptionsTask('To-do');
      } else if (taskcode == 'TRANSACTION_TYPE_CALL') {
        setOptionsTask('call');
      } else if (taskcode == 'TRANSACTION_TYPE_VOICECALL') {
        setOptionsTask('voice-call');
      }
      setScheduleDate(true);
    }
  }, [isEdit, taskToEdit]);

  return (
    <Grid container sx={style} ref={updateTaskScrollRef}>
      {expandNote && !isEdit ? (
        <Grid sx={styles.ClickBanner}>
          <Typography onClick={clicktoExpand} sx={styles.ClickText}>
            Click here to add a task
          </Typography>
        </Grid>
      ) : (
        <Grid>
          <Grid xs={12}>
            <Grid
              container
              sx={{
                display: ' flex',
                justifyContent: 'space-between',
                // alignItems: "center",
              }}
            >
              <Grid xs={8.8} xl={9.9}>
                <TextField
                  sx={{
                    width: '100%',
                    borderRadius: '0px',
                    '&.MuiOutlinedInput-input': {
                      textTransform: 'capitalize',
                    },
                    '& .MuiOutlinedInput-root': {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                    '& .MuiInputLabel-root': {
                      fontFamily: 'poppins',
                      marginRight: '0px',
                    },
                    '& .MuiFormHelperText-root': {
                      fontFamily: 'poppins',
                      marginLeft: '0px',
                    },
                  }}
                  disabled={isLoading}
                  variant="outlined"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => {
                    setSubject(e.target.value);
                    setErrorMessage((prev) => ({
                      ...prev,
                      subject: false,
                    }));
                  }}
                  InputLabelProps={{
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                  helperText={errorMessages.subject && 'Subject is required.'}
                  error={errorMessages.subject}
                />
              </Grid>
              <Grid xs={3} xl={2}>
                <FormControl fullWidth>
                  <Select
                    id="demo-simple-select"
                    onChange={(e) => setOptionsTask(e.target.value)}
                    defaultValue="To-do"
                    sx={{ ...poppins300 }}
                    disabled={isLoading}
                  >
                    <MenuItem sx={{ ...poppins300 }} value={'To-do'}>
                      To Do
                    </MenuItem>
                    <MenuItem sx={{ ...poppins300 }} value={'report'}>
                      Call
                    </MenuItem>
                    <MenuItem sx={{ ...poppins300 }} value={'report'}>
                      Voice Call
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ marginTop: '15px' }}>
            <TextField
              sx={{
                width: '100%',
                fontFamily: 'poppins',
                borderRadius: '0px',
                '& .MuiOutlinedInput-root': {
                  fontFamily: 'poppins',
                },
                '& .MuiInputLabel-root': {
                  fontFamily: 'poppins',
                },
                '& .MuiFormHelperText-root': {
                  fontFamily: 'poppins',
                  marginLeft: '0px',
                },
              }}
              disabled={isLoading}
              variant="outlined"
              placeholder="Details"
              multiline
              value={details}
              rows={6}
              onChange={(e) => {
                let value = e.target.value;
                value =
                  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                setDetails(value);
                setErrorMessage((prev) => ({
                  ...prev,
                  details: false,
                }));
              }}
              inputProps={{ style: { fontFamily: 'poppins' } }}
              helperText={errorMessages.details && 'Details are required.'}
              error={errorMessages.details}
            />
          </Grid>
          <Grid
            xs={12}
            container
            sx={{
              marginTop: '15px',
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              justifyContent: 'space-between',
            }}
          >
            <Grid item md={2.9}>
              <Stack
                direction={'row'}
                spacing={1}
                alignItems={'center'}
                component={'span'}
              >
                <IconButton
                  onClick={() => {
                    setCalender('Due');
                    setAnchorEl(true);
                  }}
                >
                  <Calendarimg />
                </IconButton>
                <Typography sx={{ ...poppins300, fontWeight: '500' }}>
                  {duedate ? duedate : 'Due Date'}
                </Typography>
              </Stack>
              {errorMessages.dueDate && (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '12px',
                    color: 'red',
                    paddingLeft: '12px',
                  }}
                >
                  Due date and time is required
                </Typography>
              )}
              {errorMessages.dateRange && (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '12px',
                    color: 'red',
                    paddingLeft: '12px',
                  }}
                >
                  Select a valid date and time
                </Typography>
              )}
            </Grid>
            {duedate && !scheduledate && (
              <Grid item md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disableRipple
                      checked={checkBox1}
                      onChange={(e) => {
                        setCalender('schedule');
                        setcheckBox1(e.target.checked);
                        setSchedule(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        ...poppins300,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Schedule follow up?
                    </Typography>
                  }
                />
              </Grid>
            )}
            <Grid item md={2.3}>
              <FormControlLabel
                control={
                  <Checkbox
                    disableRipple
                    disabled={isLoading}
                    checked={checkBox2}
                    onChange={(e) => setcheckBox2(e.target.checked)}
                    sx={{
                      p: '3px',
                    }}
                  />
                }
                label={
                  <Typography sx={{ ...poppins300 }}>Mark as done</Typography>
                }
              />
            </Grid>

            <Grid item md={2}>
              <Button
                variant="outlined"
                disabled={isLoading}
                sx={{
                  padding: '10px',
                  fontWeight: 500,
                  fontSize: '12px',
                  fontFamily: 'poppins',
                  mr: 1,
                  borderColor: 'lightgrey',
                  color: 'black',
                  whiteSpace: 'nowrap',
                }}
                onClick={(e) => {
                  setAnchorElMessage(e.currentTarget);
                }}
              >
                + Insert Template Text
              </Button>
            </Grid>
            <TemplateText
              anchorElMessage={anchorElMessage}
              setAnchorElMessage={setAnchorElMessage}
              setDetails={setDetails}
            />

            <Grid
              item
              md={1.3}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {isEdit ? (
                <Button
                  variant="outlined"
                  sx={{
                    padding: '10px 15px',
                    borderRadius: '5px',
                    fontWeight: 400,
                    letterSpacing: '1px',
                    fontSize: '12px',
                    background: '#ECE5F6',
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    border: 'none',
                    '&:hover': {
                      border: 'none',
                      background: '#e5d0ff',
                    },
                  }}
                  onClick={() => {
                    handleSaveTaskClicked();
                  }}
                  disabled={isLoading}
                >
                  Update
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  sx={{
                    padding: '10px 15px',
                    borderRadius: '5px',
                    fontWeight: 400,
                    letterSpacing: '1px',
                    fontSize: '12px',
                    background: '#ECE5F6',
                    color: '#6C2AD2',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    border: 'none',
                    '&:hover': {
                      border: 'none',
                      background: '#e5d0ff',
                    },
                  }}
                  onClick={() => {
                    handleSaveTaskClicked();
                  }}
                  disabled={isLoading}
                >
                  Save
                </Button>
              )}

              {isLoading && (
                <img
                  alt="Loader"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }} // 🔹 smaller & aligned
                />
              )}
            </Grid>
          </Grid>

          {/* date picker popover  */}
          <Popover
            open={anchorEl}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Box sx={{ p: 2 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDateTimePicker
                  value={newDateValue}
                  onClose={handleClose}
                  onAccept={(newdate) => {
                    if (!newdate) return;

                    const nowSydney = dayjs().tz('Australia/Sydney');
                    const oneHourLater = nowSydney.add(1, 'hour');
                    let newDateParsed = dayjs(newdate).tz('Australia/Sydney');

                    // If same day and before allowed time → bump to oneHourLater
                    if (
                      newDateParsed.isSame(nowSydney, 'day') &&
                      newDateParsed.isBefore(oneHourLater)
                    ) {
                      newDateParsed = oneHourLater.add(1, 'minute');
                    }

                    if (newDateParsed.isBefore(oneHourLater)) {
                      setAnchorEl(null);
                      if (calender === 'Due') {
                        setErrorMessage((prev) => ({
                          ...prev,
                          dateRange: true,
                        }));
                      }
                      if (calender === 'schedule') {
                        setErrorMessageSch((prev) => ({
                          ...prev,
                          dateRangeSch: true,
                        }));
                      }
                      return;
                    }

                    // ✅ Always update state, even if user just pressed OK
                    setnewDate(newDateParsed);
                    getDateValue(newDateParsed);
                  }}
                  orientation={matchessm ? 'portrait' : 'landscape'}
                  disablePast={true}
                  minDateTime={
                    calender === 'Due'
                      ? oneHourLaterDueDate
                      : twoHourLaterDueDate
                  }
                  onChange={(newdate) => {
                    if (!newdate) return;

                    const nowSydney = dayjs().tz('Australia/Sydney');
                    const oneHourLater = nowSydney.add(1, 'hour');
                    let newDateParsed = dayjs(newdate).tz('Australia/Sydney');

                    if (
                      newDateParsed.isSame(nowSydney, 'day') &&
                      newDateParsed.isBefore(oneHourLater)
                    ) {
                      newDateParsed = oneHourLater.add(1, 'minute');
                      setnewDate(newDateParsed);
                      getDateValue(newDateParsed);
                    } else {
                      setnewDate(newDateParsed);
                      //getDateValue(newDateParsed);
                    }

                    // clear errors
                    if (calender === 'Due') {
                      setErrorMessage((prev) => ({
                        ...prev,
                        dueDate: false,
                        dateRange: false,
                      }));
                    }
                    if (calender === 'schedule') {
                      setErrorMessageSch((prev) => ({
                        ...prev,
                        dateSch: false,
                        dateRangeSch: false,
                      }));
                    }
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Popover>
          {/* Call Outcome dialog  */}
          <Dialog
            open={taskSave}
            aria-labelledby="task-dialog-title"
            fullWidth
            maxWidth={'md'}
            PaperProps={{
              sx: {
                maxWidth: matchessm ? '100vw' : 'auto',
                maxHeight: matchessm ? '100vh' : 'auto',
                margin: '0px',
                width: matchessm ? '100vw' : 'auto',
              },
            }}
            sx={{ marginTop: !matchessm ? '90px' : '0px' }}
          >
            <DialogTitle
              sx={{
                ...poppins300,
                fontWeight: '600',
                fontSize: matchessm ? '20px' : '24px',
                pl: matchessm ? '10px' : '30px',
                pt: matchessm ? '20px' : '40px',
              }}
              textAlign={'start'}
              id="task-dialog-title"
            >
              Call Outcome
            </DialogTitle>
            <DialogContent
              sx={{
                padding: matchessm ? '30px 10px' : 'auto',
              }}
            >
              <Stack
                direction={'row'}
                spacing={matchessm ? 2 : 8}
                flexWrap={'nowrap'}
                py={matchessm ? 2 : 5}
              >
                <Stack
                  direction={'column'}
                  justifyContent={'space-evenly'}
                  alignItems={'center'}
                  sx={{
                    width: '116px',
                    height: '116px',
                    backgroundColor:
                      callcategory == 'Did Not Connect'
                        ? 'rgba(249, 57, 57, 0.1)'
                        : '#F8F8F8',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setCallcategory('Did Not Connect');
                  }}
                >
                  <Box>
                    <DidnotConnectIcon
                      color={
                        callcategory == 'Did Not Connect'
                          ? '#CB5B66'
                          : '#666666'
                      }
                    />
                  </Box>
                  <Typography
                    sx={{
                      ...poppins300,
                      textAlign: 'center',
                      fontSize: '12px',
                      color:
                        callcategory == 'Did Not Connect'
                          ? '#CB5B66'
                          : '#666666',
                    }}
                  >
                    Did Not Connect
                  </Typography>
                </Stack>
                <Stack
                  direction={'column'}
                  justifyContent={'space-evenly'}
                  alignItems={'center'}
                  sx={{
                    width: '116px',
                    height: '116px',
                    backgroundColor:
                      callcategory == 'No Voicemail Left'
                        ? 'rgba(249, 57, 57, 0.1)'
                        : '#F8F8F8',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setCallcategory('No Voicemail Left');
                  }}
                >
                  <Box>
                    <NoVoicemailLeftIcon
                      color={
                        callcategory == 'No Voicemail Left'
                          ? '#CB5B66'
                          : '#666666'
                      }
                    />
                  </Box>
                  <Typography
                    sx={{
                      ...poppins300,
                      textAlign: 'center',
                      fontSize: '12px',
                      color:
                        callcategory == 'No Voicemail Left'
                          ? '#CB5B66'
                          : '#666666',
                    }}
                  >
                    No Voicemail Left
                  </Typography>
                </Stack>
                <Stack
                  direction={'column'}
                  justifyContent={'space-evenly'}
                  alignItems={'center'}
                  sx={{
                    width: '116px',
                    height: '116px',
                    backgroundColor:
                      callcategory == 'Voicemail Left'
                        ? 'rgba(249, 57, 57, 0.1)'
                        : '#F8F8F8',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setCallcategory('Voicemail Left');
                  }}
                >
                  <Box>
                    <VoicemailLeftIcon
                      color={
                        callcategory == 'Voicemail Left' ? '#CB5B66' : '#666666'
                      }
                    />
                  </Box>
                  <Typography
                    sx={{
                      ...poppins300,
                      textAlign: 'center',
                      fontSize: '12px',
                      color:
                        callcategory == 'Voicemail Left'
                          ? '#CB5B66'
                          : '#666666',
                    }}
                  >
                    Voicemail Left
                  </Typography>
                </Stack>
                <Stack
                  direction={'column'}
                  justifyContent={'space-evenly'}
                  alignItems={'center'}
                  sx={{
                    width: '116px',
                    height: '116px',
                    backgroundColor:
                      callcategory == 'Call Connected'
                        ? 'rgba(249, 57, 57, 0.1)'
                        : '#F8F8F8',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setCallcategory('Call Connected');
                  }}
                >
                  <Box>
                    <CallConnectedIcon
                      color={
                        callcategory == 'Call Connected' ? '#CB5B66' : '#666666'
                      }
                    />
                  </Box>
                  <Typography
                    sx={{
                      ...poppins300,
                      textAlign: 'center',
                      fontSize: '12px',
                      color:
                        callcategory == 'Call Connected'
                          ? '#CB5B66'
                          : '#666666',
                    }}
                  >
                    Call Connected
                  </Typography>
                </Stack>
              </Stack>
              <Typography
                sx={{
                  ...poppins300,
                  fontWeight: '600',
                  fontSize: matchessm ? '20px' : '24px',
                }}
              >
                Update Overdue Tasks
              </Typography>
              <Stack direction={'column'} spacing={2} sx={{ p: 2 }}>
                <TaskListCard />
                <TaskListCard />
              </Stack>
            </DialogContent>
            <DialogActions
              sx={{
                display: 'flex',
                justifyContent: 'end',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  padding: '10px 15px',
                  fontWeight: 400,
                  letterSpacing: '1px',
                  fontSize: '12px',
                  background: '#ECE5F6',
                  color: '#6C2AD2',
                  fontFamily: 'poppins',
                  textTransform: 'capitalize',
                  border: 'none',
                  '&:hover': {
                    border: 'none',
                    background: '#e5d0ff',
                  },
                }}
                onClick={() => {
                  settaskSave(false);
                  if (checkBox2) {
                    setSchedule(true);
                  }
                  // submitForm();
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={schedule}
            // hideBackdrop
            aria-labelledby="task-dialog-title"
            fullWidth
            maxWidth={'md'}
            sx={{ marginTop: '90px' }}
          >
            <DialogTitle
              sx={{
                ...poppins300,
                fontWeight: '600',
                fontSize: 24,
                pl: '30px',
                pt: '40px',
              }}
              textAlign={'start'}
              id="task-dialog-title"
            >
              Schedule Follow-up Task
            </DialogTitle>
            <DialogContent>
              <Grid
                item
                sx={{
                  display: 'flex',
                  justifyContent: 'right',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '10px',
                    alignItems: 'flex-start',
                  }}
                >
                  <LocationIcon />
                  <Typography
                    sx={{
                      ...poppins300,
                      fontSize: '12px',
                    }}
                  >
                    {selectedProperty}
                  </Typography>
                  <ArrowDown />
                </Box>
                <Box>
                  <CancelOutlinedIcon />
                </Box>
              </Grid>
              <Grid container sx={style}>
                <Grid>
                  <Grid xs={12}>
                    <Grid
                      xs={12}
                      sm={12}
                      container
                      sx={{
                        display: ' flex',
                        justifyContent: 'space-between',
                        // gap:"10px",
                      }}
                    >
                      <Grid xs={12} xl={12}>
                        <TextField
                          sx={{
                            width: '100%',
                            borderRadius: '0px',
                            '&.MuiOutlinedInput-input': {
                              textTransform: 'capitalize',
                            },
                            '& .MuiOutlinedInput-root': {
                              fontFamily: 'poppins',
                            },
                            '& .MuiInputLabel-root': {
                              fontFamily: 'poppins',
                              // border:"1px solid green",
                              marginRight: '0px',
                            },
                            '& .MuiFormHelperText-root': {
                              fontFamily: 'poppins',
                              marginLeft: '0px',
                            },
                          }}
                          disabled={isLoading}
                          variant="outlined"
                          placeholder="Subject"
                          value={subjectsch}
                          onChange={(e) => {
                            setSubjectsch(e.target.value);
                            setErrorMessageSch((prev) => ({
                              ...prev,
                              subjectSch: false,
                            }));
                          }}
                          InputLabelProps={{
                            style: {
                              fontFamily: 'poppins',
                              textTransform: 'capitalize',
                            },
                          }}
                          helperText={
                            errorMessagesSch.subjectSch &&
                            'Subject is required.'
                          }
                          error={errorMessagesSch.subjectSch}
                        />
                      </Grid>
                      {/* <Grid
            xs={3}
            xl={2}
            sx={{
              display: "flex",
              justifyContent: "space-around",
              // border: "1px solid #D9D9D9",
              // padding: "15px",
              borderRadius: "4px",
              fontWeight: 400,
            }}
          >
            <FormControl fullWidth>
              <Select
                id="demo-simple-select"
                onChange={(e) => setOptions(e.target.value)}
                defaultValue="call"
                sx={{ ...poppins300 }}
              >
                <MenuItem sx={{ ...poppins300 }} value={"call"}>
                  To Do
                </MenuItem>
                <MenuItem sx={{ ...poppins300 }} value={"report"}>
                  Call
                </MenuItem>
                <MenuItem sx={{ ...poppins300 }} value={"report"}>
                  Voice Call
                </MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
                    </Grid>
                  </Grid>
                  <Grid xs={12} sx={{ marginTop: '15px' }}>
                    <TextField
                      sx={{
                        width: '100%',
                        borderRadius: '0px',
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'poppins',
                        },
                        '& .MuiInputLabel-root': {
                          fontFamily: 'poppins',
                        },
                        '& .MuiFormHelperText-root': {
                          fontFamily: 'poppins',
                          marginLeft: '0px',
                        },
                      }}
                      disabled={isLoading}
                      variant="outlined"
                      placeholder="Details"
                      multiline
                      value={detailssch}
                      rows={6}
                      onChange={(e) => {
                        let value = e.target.value;
                        value =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();
                        setDetailssch(value);
                        setErrorMessageSch((prev) => ({
                          ...prev,
                          detailsSch: false,
                        }));
                      }}
                      inputProps={{ style: { fontFamily: 'poppins' } }}
                      helperText={
                        errorMessagesSch.detailsSch && 'Details are required.'
                      }
                      error={errorMessagesSch.detailsSch}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      justifyContent: 'space-between',
                      fontFamily: 'poppins',
                      marginTop: '20px',
                    }}
                  >
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      component={'span'}
                    >
                      <IconButton onClick={() => setAnchorEl(true)}>
                        <Calendarimg
                          onClick={() => {
                            setCalender('schedule');
                            setAnchorEl(true);
                          }}
                        />
                      </IconButton>
                      <Typography sx={{ ...poppins300, fontWeight: '500' }}>
                        {' '}
                        {filterDate}
                      </Typography>
                      {errorMessagesSch.dateSch && (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontSize: '12px',
                            color: 'red',
                            paddingLeft: '12px',
                          }}
                        >
                          Date and time is required
                        </Typography>
                      )}
                      {errorMessagesSch.dateRangeSch && (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontSize: '12px',
                            color: 'red',
                            paddingLeft: '12px',
                          }}
                        >
                          Please select a valid time and date.
                        </Typography>
                      )}
                    </Stack>
                    <Typography display={'flex'} gap={3}>
                      <Button
                        variant="outlined"
                        sx={{
                          padding: '10px',
                          fontWeight: 500,
                          fontSize: '12px',
                          fontFamily: 'poppins',
                          color: 'black',
                          borderColor: '#D9D9D9',
                        }}
                        onClick={(e) => {
                          setAnchorElMessage(e.currentTarget);
                        }}
                      >
                        + Insert Template Text
                      </Button>
                      <Button
                        // disabled={butValue}
                        variant="outlined"
                        sx={{
                          width: '60px',
                          padding: '8px 15px',
                          fontWeight: 400,
                          borderRadius: '10px',
                          letterSpacing: '1px',
                          fontSize: '12px',
                          background: '#ECE5F6',
                          color: '#6C2AD2',
                          fontFamily: 'poppins',
                          border: 'none',
                          '&:hover': {
                            border: 'none',
                            background: '#e5d0ff',
                          },
                        }}
                        onClick={() => {
                          handleSaveSchClicked();
                        }}
                      >
                        Save
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <TemplateText
              anchorElMessage={anchorElMessage}
              setAnchorElMessage={setAnchorElMessage}
              setDetails={setDetailssch}
            />
          </Dialog>
        </Grid>
      )}
    </Grid>
  );
}

function TaskListCard() {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: '5px',
        borderColor: 'transparent',
        boxShadow: ' 0px 1px 4px 0px #00000026',
        padding: '15px',
        bgcolor: 'white',
        // bgcolor: 'rgba(108, 42, 210, 0.1)'
      }}
    >
      <Stack
        direction={'row'}
        spacing={2}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={1}
      >
        <Stack
          direction={'row'}
          justifyContent={'start'}
          alignItems={'center'}
          sx={{ pl: 0, ml: '-5px !important', width: '80%' }}
        >
          <IconButton>
            {/* <CheckRoundIcon/> */}
            <CheckedRoundIcon />
          </IconButton>
          <Typography
            // component={"del"}
            sx={{ ...poppins500, fontSize: '16px' }}
          >
            Task : Call
          </Typography>
        </Stack>
        <IconButton disableRipple>
          <ArrowDown />
        </IconButton>
      </Stack>

      <Typography
        component={'div'}
        sx={{
          ...poppins500,
          fontSize: '14px',
          color: '#4CAF50',
          mb: 1,
          // color:"rgba(228, 88, 87, 1)"
        }}
      >
        Today
      </Typography>
      <Stack
        direction={matchessm ? 'column' : 'row'}
        spacing={2}
        alignItems={matchessm ? 'flex-start' : 'center'}
        mb={1}
      >
        <Typography sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}>
          Created: 15 May (9:01am){' '}
        </Typography>
        <Typography sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}>
          Added by Kiel Glass{' '}
        </Typography>
        <Typography
          whiteSpace={'nowrap'}
          display={'flex'}
          alignItems={'center'}
          gap={1}
          justifyContent={'center'}
          sx={{
            ...poppins300,
            fontSize: '12px',
            color: '#666666',
          }}
        >
          <LocationIcon />
          56 Owen Street, North Bondi
        </Typography>
      </Stack>
      <Stack
        direction={'row'}
        spacing={matchessm ? 1 : 2}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography
          sx={{
            ...poppins400,
            fontSize: '14px',
            color: '#200E32',
            width: '80%',
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Netus sed
          porttitor tincidunt est amet enim. Quis ac sagittis, vulputate at amet
          facilisi dignissim integer. Suspendisse pharetra integer scelerisque{' '}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: matchessm ? 'column' : 'row',
            alignItems: 'flex-end',
          }}
        >
          <IconButton>
            <TaskEditIcon />
          </IconButton>
          <IconButton>
            <TaskDeleteIcon />
          </IconButton>
        </Box>
      </Stack>
    </Card>
  );
}
